import {
  ProductionFulfillmentApi,
  RequestContext,
  useAPIAction,
} from "melco-shared-logic";

const addContentTypeHeader = (context: RequestContext) => {
  return new Promise<void>((resolve) => {
    context.init.headers = {
      ...context.init.headers,
      "Content-Type": "text/plain",
    };
    resolve();
  });
};

export const useDownloadLogJob = (logId: string, jobId: string) => {
  return useAPIAction(
    ProductionFulfillmentApi,
    async (api) => {
      const data = await api
        .withPreMiddleware(addContentTypeHeader)
        .productionFulfillmentRunsDownloadLogsData({
          id: logId,
          jobId: jobId,
        });

      return {
        successMessages: [],
        data,
      };
    },
    { translationPrefix: "global" }
  );
};
